export function setMenuMinimized(configs){
    return{
        type: "ALTERARMENU",
        configs
    }
}